let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8PW9S")).then(() => parcelRequire('975wj'));